module.exports = __webpack_public_path__ + "img/V8.49929af5.png";